var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{attrs:{"isLogin":true}},[_c('div',{attrs:{"slot":"epassport"},slot:"epassport"},[(_vm.showIframe)?_c('iframe',{ref:"iframe",attrs:{"src":_vm.IFRAME_URL}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }